import MyTopProducts from './MyTopProducts';

import { connect } from 'react-redux';

import { analyticsActions } from 'src/analytics/store';

const mapStateToProps = (state: any) => ({
  isLoggedIn: state.signin.success
});

interface IDispatchFromProps {
  fireProductImpressionEvent(data: any): void;
  fireProductClickEvent(data: any): void;
}

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  fireProductImpressionEvent: (data: any) =>
    dispatch(analyticsActions.productImpression(data)),
  fireProductClickEvent: (data: any) =>
    dispatch(analyticsActions.productClick(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(MyTopProducts);
